import { DOMSerializer, Fragment } from '@tiptap/pm/model';
import { renderFbcCheckList } from '../Extensions/Lists/FbcCheckList.js';
import { renderFbcNumberList } from '../Extensions/Lists/FbcNumberList.js';
import { renderFbcToggleList } from '../Extensions/Lists/FbcToggleList.js';
import { renderFbcBulletList } from '../Extensions/Lists/FbcBulletList.js';

const customRenderingNodes = [
  "fbcCheckList",
  "fbcNumberList",
  "fbcToggleList",
  "fbcBulletList"
];
const createPlaceholderDocFromFragment = (fragment, schema) => {
  const doc = schema.nodes.placeholderDoc.create(null, fragment);
  return doc;
};
class FbcDOMSerializer extends DOMSerializer {
  constructor(nodes, marks, customRendering = false) {
    super(nodes, marks);
    this.customRendering = false;
    this.customRendering = customRendering;
  }
  serializeFragment(fragment, _options, target) {
    let placeholderDoc = _options?.placeholderDoc;
    const firstChild = fragment.firstChild;
    if (!placeholderDoc && firstChild) {
      placeholderDoc = createPlaceholderDocFromFragment(fragment, firstChild.type.schema);
    }
    const options = {
      ..._options,
      placeholderDoc
    };
    const result = super.serializeFragment(fragment, options, target);
    const adjacentLists = result.querySelectorAll('ul[data-type="fbc-bullet-list"] + ul[data-type="fbc-bullet-list"], ol[data-type="fbc-number-list"] + ol[data-type="fbc-number-list"], ul[data-type="fbc-check-list"] + ul[data-type="fbc-check-list"]');
    const dealtAdjacentLists = /* @__PURE__ */ new Set();
    for (let i = adjacentLists.length - 1; i >= 0; i--) {
      let target2 = adjacentLists[i];
      if (dealtAdjacentLists.has(target2) || !(target2 instanceof HTMLElement)) continue;
      do {
        const prevSibling = target2.previousElementSibling;
        if (!prevSibling || !(prevSibling instanceof HTMLElement) || !(target2 instanceof HTMLElement) || prevSibling.dataset.type !== target2.dataset.type) break;
        const targetContent = target2.innerHTML;
        prevSibling.innerHTML += targetContent;
        target2.remove();
        target2 = prevSibling;
      } while (target2);
    }
    return result;
  }
  // @ts-expect-error - it's an internal function but we do need to override it
  serializeNodeInner(node, _options) {
    let placeholderDoc = _options?.placeholderDoc;
    if (!placeholderDoc) {
      placeholderDoc = createPlaceholderDocFromFragment(Fragment.from(node), node.type.schema);
    }
    const options = {
      ..._options,
      placeholderDoc
    };
    if (!this.customRendering || !("type" in node) || !customRenderingNodes.includes(node.type.name)) {
      return super.serializeNodeInner(node, options);
    }
    let pos = 0;
    placeholderDoc.descendants((child, childPos) => {
      if (child === node) {
        pos = childPos;
        return false;
      }
      return true;
    });
    switch (node.type.name) {
      case "fbcCheckList": {
        const { contentDOM, dom } = renderFbcCheckList(node);
        this.serializeFragment(node.content, options, contentDOM);
        return dom;
      }
      case "fbcNumberList": {
        const { contentDOM, dom } = renderFbcNumberList(node, placeholderDoc, pos);
        this.serializeFragment(node.content, options, contentDOM);
        return dom;
      }
      case "fbcToggleList": {
        const { contentDOM, dom } = renderFbcToggleList(node);
        this.serializeFragment(node.content, options, contentDOM);
        return dom;
      }
      case "fbcBulletList": {
        const { contentDOM, dom } = renderFbcBulletList(node, placeholderDoc, pos);
        this.serializeFragment(node.content, options, contentDOM);
        return dom;
      }
    }
    throw new Error(`Unknown node type: ${node.type.name}`);
  }
  static fromSchema(schema, customRendering = false) {
    return schema.cached.domSerializer instanceof FbcDOMSerializer ? schema.cached.domSerializer : new FbcDOMSerializer(this.nodesFromSchema(schema), this.marksFromSchema(schema), customRendering);
  }
}

export { FbcDOMSerializer };
//# sourceMappingURL=FbcDOMSerializer.js.map
